/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../../../../common/time';
import '../../../../common/currency';
import '../../../../common/countries';
import '../../../offer/models';
import '../../../common';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "capital": {
        "nested": {
          "external": {
            "nested": {
              "business": {
                "nested": {
                  "models": {
                    "nested": {
                      "offers": {
                        "nested": {
                          "Product": {
                            "fields": {
                              "token": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "instrument": {
                                "type": "squareup.capital.external.business.models.offers.Product.FinancialInstrument",
                                "id": 2,
                                "rule": "optional"
                              },
                              "repaymentMechanism": {
                                "type": "squareup.capital.external.business.models.offers.Product.RepaymentMechanism",
                                "id": 3,
                                "rule": "optional"
                              },
                              "usages": {
                                "type": "squareup.capital.external.business.models.offers.Product.Usage",
                                "id": 4,
                                "rule": "repeated"
                              }
                            },
                            "nested": {
                              "RepaymentMechanism": {
                                "values": {
                                  "PM_DO_NOT_USE": 0,
                                  "NOT_APPLICABLE": 1,
                                  "PORTION_OF_SALES": 2,
                                  "FIXED_PAYMENTS": 3
                                }
                              },
                              "FinancialInstrument": {
                                "values": {
                                  "FI_DO_NOT_USE": 0,
                                  "CASH_ADVANCE": 1,
                                  "LOAN": 2
                                }
                              },
                              "Usage": {
                                "values": {
                                  "USAGE_DO_NOT_USE": 0,
                                  "SHORT_TERM": 1,
                                  "WORKING_CAPITAL": 2,
                                  "EXPANSION": 3
                                }
                              }
                            }
                          },
                          "OfferSet": {
                            "fields": {
                              "token": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "customerToken": {
                                "type": "string",
                                "id": 2,
                                "rule": "optional"
                              },
                              "expiresAt": {
                                "type": "squareup.common.time.DateTime",
                                "id": 3,
                                "rule": "optional"
                              },
                              "offers": {
                                "type": "squareup.capital.external.business.models.offers.Offer",
                                "id": 4,
                                "rule": "repeated"
                              },
                              "isExpired": {
                                "type": "bool",
                                "id": 5,
                                "rule": "optional"
                              },
                              "bankLinkingBonusAmount": {
                                "type": "squareup.common.Money",
                                "id": 6,
                                "rule": "optional"
                              },
                              "countryCode": {
                                "type": "squareup.common.countries.Country",
                                "id": 7,
                                "rule": "optional"
                              },
                              "bizConfiguration": {
                                "type": "squareup.capital.offer.models.BizConfiguration",
                                "id": 8,
                                "rule": "optional"
                              },
                              "isCounterOffer": {
                                "type": "bool",
                                "id": 9,
                                "rule": "optional"
                              },
                              "productName": {
                                "type": "string",
                                "id": 10,
                                "rule": "optional"
                              },
                              "expiresSoon": {
                                "type": "bool",
                                "id": 11,
                                "rule": "optional"
                              },
                              "ficoBoostMaxAmount": {
                                "type": "squareup.common.Money",
                                "id": 12,
                                "rule": "optional"
                              },
                              "maxBoostAmount": {
                                "type": "squareup.common.Money",
                                "id": 13,
                                "rule": "optional"
                              },
                              "isImprovedOffer": {
                                "type": "bool",
                                "id": 14,
                                "rule": "optional"
                              }
                            }
                          },
                          "OfferBlocker": {
                            "fields": {
                              "type": {
                                "type": "squareup.capital.external.business.models.offers.OfferBlocker.BlockerType",
                                "id": 1,
                                "rule": "optional"
                              },
                              "unblockActions": {
                                "type": "squareup.capital.external.business.models.offers.OfferBlocker.UnblockAction",
                                "id": 2,
                                "rule": "repeated"
                              }
                            },
                            "nested": {
                              "BlockerType": {
                                "values": {
                                  "OB_BT_DO_NOT_USE": 0,
                                  "EXTERNAL_TRANSACTION_DATA": 1
                                }
                              },
                              "UnblockAction": {
                                "values": {
                                  "OB_AU_DO_NOT_USE": 0,
                                  "LINK_BANK_ACCOUNT": 1
                                }
                              }
                            }
                          },
                          "Offer": {
                            "fields": {
                              "token": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "offerSetToken": {
                                "type": "string",
                                "id": 2,
                                "rule": "optional"
                              },
                              "productToken": {
                                "type": "string",
                                "id": 3,
                                "rule": "optional"
                              },
                              "blockers": {
                                "type": "squareup.capital.external.business.models.offers.OfferBlocker",
                                "id": 4,
                                "rule": "repeated"
                              },
                              "ampMultiplier": {
                                "type": "string",
                                "id": 5,
                                "rule": "optional"
                              },
                              "loanAgreementLink": {
                                "type": "string",
                                "id": 6,
                                "rule": "optional"
                              },
                              "loanAgreementLastUpdatedAt": {
                                "type": "squareup.common.time.DateTime",
                                "id": 7,
                                "rule": "optional"
                              },
                              "isActive": {
                                "type": "bool",
                                "id": 8,
                                "rule": "optional"
                              },
                              "countryCode": {
                                "type": "squareup.common.countries.Country",
                                "id": 9,
                                "rule": "optional"
                              },
                              "bankName": {
                                "type": "string",
                                "id": 10,
                                "rule": "optional"
                              },
                              "bankAccountSuffix": {
                                "type": "string",
                                "id": 11,
                                "rule": "optional"
                              },
                              "availableLoanDepositLocations": {
                                "type": "squareup.capital.common.LoanDepositLocation",
                                "id": 12,
                                "rule": "repeated"
                              },
                              "isCca": {
                                "type": "bool",
                                "id": 400,
                                "rule": "optional"
                              },
                              "financingTermsLoan": {
                                "type": "squareup.capital.external.business.models.offers.FinancingTerms.Loan",
                                "id": 100
                              },
                              "repaymentTermsPortionOfSales": {
                                "type": "squareup.capital.external.business.models.offers.RepaymentTerms.PortionOfSales",
                                "id": 200
                              },
                              "repaymentTermsFixedPayments": {
                                "type": "squareup.capital.external.business.models.offers.RepaymentTerms.FixedPayments",
                                "id": 201
                              }
                            },
                            "nested": {
                              "financing_terms": {
                                "oneof": ["financingTermsLoan"]
                              },
                              "repayment_terms": {
                                "oneof": ["repaymentTermsPortionOfSales", "repaymentTermsFixedPayments"]
                              }
                            }
                          },
                          "FinancingTerms": {
                            "nested": {
                              "Loan": {
                                "fields": {
                                  "financedAmount": {
                                    "type": "squareup.common.Money",
                                    "id": 1,
                                    "rule": "optional"
                                  },
                                  "feeAmount": {
                                    "type": "squareup.common.Money",
                                    "id": 2,
                                    "rule": "optional"
                                  },
                                  "depositAmount": {
                                    "type": "squareup.common.Money",
                                    "id": 3,
                                    "rule": "optional"
                                  },
                                  "outstandingBalanceAmount": {
                                    "type": "squareup.common.Money",
                                    "id": 4,
                                    "rule": "optional"
                                  },
                                  "totalOwedAmount": {
                                    "type": "squareup.common.Money",
                                    "id": 5,
                                    "rule": "optional"
                                  },
                                  "aprBps": {
                                    "type": "int64",
                                    "id": 6,
                                    "rule": "optional"
                                  },
                                  "lateFeeBps": {
                                    "type": "int64",
                                    "id": 7,
                                    "rule": "optional"
                                  },
                                  "postMaturitySweeperBps": {
                                    "type": "int64",
                                    "id": 8,
                                    "rule": "optional"
                                  },
                                  "feeAmountBps": {
                                    "type": "int64",
                                    "id": 9,
                                    "rule": "optional"
                                  },
                                  "financedAmountCap": {
                                    "type": "squareup.capital.external.business.models.offers.FinancingTerms.Loan.FinancedAmountCap",
                                    "id": 10,
                                    "rule": "optional"
                                  },
                                  "interestRateBps": {
                                    "type": "int64",
                                    "id": 11,
                                    "rule": "optional"
                                  },
                                  "numberPaymentPeriods": {
                                    "type": "int32",
                                    "id": 12,
                                    "rule": "optional"
                                  },
                                  "estimatedRepaymentDays": {
                                    "type": "int32",
                                    "id": 13,
                                    "rule": "optional"
                                  }
                                },
                                "nested": {
                                  "FinancedAmountCap": {
                                    "values": {
                                      "FAC_DO_NOT_USE": 0,
                                      "UNKNOWN": 1,
                                      "NONE": 2,
                                      "MAX_AMOUNT": 3,
                                      "MAX_AMOUNT_PER_EMPLOYEE": 4
                                    }
                                  }
                                }
                              }
                            }
                          },
                          "RepaymentTerms": {
                            "nested": {
                              "PortionOfSales": {
                                "fields": {
                                  "holdRateBps": {
                                    "type": "int64",
                                    "id": 1,
                                    "rule": "optional"
                                  },
                                  "minimumPaymentAmount": {
                                    "type": "squareup.common.Money",
                                    "id": 2,
                                    "rule": "optional"
                                  },
                                  "activeHoldRateBps": {
                                    "type": "int64",
                                    "id": 3,
                                    "rule": "optional"
                                  },
                                  "effectiveTotalHoldRateBps": {
                                    "type": "int64",
                                    "id": 4,
                                    "rule": "optional"
                                  }
                                }
                              },
                              "FixedPayments": {
                                "fields": {
                                  "paymentAmount": {
                                    "type": "squareup.common.Money",
                                    "id": 1,
                                    "rule": "optional"
                                  },
                                  "finalPaymentAmount": {
                                    "type": "squareup.common.Money",
                                    "id": 2,
                                    "rule": "optional"
                                  },
                                  "paymentCount": {
                                    "type": "int64",
                                    "id": 3,
                                    "rule": "optional"
                                  },
                                  "paymentFrequency": {
                                    "type": "squareup.capital.external.business.models.offers.RepaymentTerms.FixedPayments.PaymentFrequency",
                                    "id": 4,
                                    "rule": "optional"
                                  },
                                  "firstPaymentDate": {
                                    "type": "squareup.common.time.DateTime",
                                    "id": 5,
                                    "rule": "optional"
                                  },
                                  "fallbackHoldRate": {
                                    "type": "int64",
                                    "id": 6,
                                    "rule": "optional"
                                  }
                                },
                                "nested": {
                                  "PaymentFrequency": {
                                    "values": {
                                      "PF_DO_NOT_USE": 0,
                                      "MONTHLY": 1
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.models?.nested?.offers?.nested?.Product && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.models?.nested?.offers?.nested?.Product?.nested?.RepaymentMechanism && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.models?.nested?.offers?.nested?.Product?.nested?.FinancialInstrument && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.models?.nested?.offers?.nested?.Product?.nested?.Usage && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.models?.nested?.offers?.nested?.OfferSet && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.models?.nested?.offers?.nested?.OfferBlocker && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.models?.nested?.offers?.nested?.OfferBlocker?.nested?.BlockerType && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.models?.nested?.offers?.nested?.OfferBlocker?.nested?.UnblockAction && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.models?.nested?.offers?.nested?.Offer && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.models?.nested?.offers?.nested?.FinancingTerms?.nested?.Loan && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.models?.nested?.offers?.nested?.FinancingTerms?.nested?.Loan?.nested?.FinancedAmountCap && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.models?.nested?.offers?.nested?.RepaymentTerms?.nested?.PortionOfSales && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.models?.nested?.offers?.nested?.RepaymentTerms?.nested?.FixedPayments && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.models?.nested?.offers?.nested?.RepaymentTerms?.nested?.FixedPayments?.nested?.PaymentFrequency) {
  $root.addJSON(jsonData);
}

/**
 * Philosophy here is that we think of different products as being a combination
 * repayment mechanism, business usage, and some type of financial instrument.
 * The server represents products with a product name, but those are an
 * implementation detail that do not need to be exposed to the client.
 *
 * SOURCE Product @ squareup/capital/external/business/models/offers.proto at 22:1
 */
export const Product = $root.lookupType('squareup.capital.external.business.models.offers.Product');
fixType(Product, {
  token: {
    required: true
  },
  instrument: {
    required: true
  },
  repaymentMechanism: {
    required: true
  },
  usages: {
    required: true
  }
});
Builder.createAndAttachToType(Product);
/**
 * SOURCE RepaymentMechanism @ squareup/capital/external/business/models/offers.proto at 23:3
 */
Product.RepaymentMechanism = $root.lookupEnum('squareup.capital.external.business.models.offers.Product.RepaymentMechanism').values;
/**
 * SOURCE FinancialInstrument @ squareup/capital/external/business/models/offers.proto at 30:3
 */
Product.FinancialInstrument = $root.lookupEnum('squareup.capital.external.business.models.offers.Product.FinancialInstrument').values;
/**
 * SOURCE Usage @ squareup/capital/external/business/models/offers.proto at 38:3
 */
Product.Usage = $root.lookupEnum('squareup.capital.external.business.models.offers.Product.Usage').values;
/**
 * SOURCE OfferSet @ squareup/capital/external/business/models/offers.proto at 53:1
 */
export const OfferSet = $root.lookupType('squareup.capital.external.business.models.offers.OfferSet');
fixType(OfferSet, {
  token: {
    required: true
  },
  customerToken: {
    required: true
  }
});
Builder.createAndAttachToType(OfferSet);
/**
 * SOURCE OfferBlocker @ squareup/capital/external/business/models/offers.proto at 108:1
 */
export const OfferBlocker = $root.lookupType('squareup.capital.external.business.models.offers.OfferBlocker');
fixType(OfferBlocker, {
  type: {
    required: true
  }
});
Builder.createAndAttachToType(OfferBlocker);
/**
 * SOURCE BlockerType @ squareup/capital/external/business/models/offers.proto at 109:3
 */
OfferBlocker.BlockerType = $root.lookupEnum('squareup.capital.external.business.models.offers.OfferBlocker.BlockerType').values;
/**
 * SOURCE UnblockAction @ squareup/capital/external/business/models/offers.proto at 114:3
 */
OfferBlocker.UnblockAction = $root.lookupEnum('squareup.capital.external.business.models.offers.OfferBlocker.UnblockAction').values;
/**
 * SOURCE Offer @ squareup/capital/external/business/models/offers.proto at 127:1
 */
export const Offer = $root.lookupType('squareup.capital.external.business.models.offers.Offer');
fixType(Offer, {
  token: {
    required: true
  },
  offerSetToken: {
    required: true
  },
  productToken: {
    required: true
  }
});
Builder.createAndAttachToType(Offer);
/**
 * SOURCE FinancingTerms @ squareup/capital/external/business/models/offers.proto at 193:1
 */
export const FinancingTerms = {};
/**
 * SOURCE Loan @ squareup/capital/external/business/models/offers.proto at 194:3
 */
FinancingTerms.Loan = $root.lookupType('squareup.capital.external.business.models.offers.FinancingTerms.Loan');
fixType(FinancingTerms.Loan, {
  financedAmount: {
    required: true
  },
  feeAmount: {
    required: true
  },
  depositAmount: {
    required: true
  },
  outstandingBalanceAmount: {
    required: true
  },
  totalOwedAmount: {
    required: true
  },
  aprBps: {
    required: true
  }
});
Builder.createAndAttachToType(FinancingTerms.Loan);
/**
 * SOURCE FinancedAmountCap @ squareup/capital/external/business/models/offers.proto at 224:5
 */
FinancingTerms.Loan.FinancedAmountCap = $root.lookupEnum('squareup.capital.external.business.models.offers.FinancingTerms.Loan.FinancedAmountCap').values;
/**
 * SOURCE RepaymentTerms @ squareup/capital/external/business/models/offers.proto at 244:1
 */
export const RepaymentTerms = {};
/**
 * SOURCE PortionOfSales @ squareup/capital/external/business/models/offers.proto at 245:3
 */
RepaymentTerms.PortionOfSales = $root.lookupType('squareup.capital.external.business.models.offers.RepaymentTerms.PortionOfSales');
fixType(RepaymentTerms.PortionOfSales, {
  holdRateBps: {
    required: true
  }
});
Builder.createAndAttachToType(RepaymentTerms.PortionOfSales);
/**
 * SOURCE FixedPayments @ squareup/capital/external/business/models/offers.proto at 260:3
 */
RepaymentTerms.FixedPayments = $root.lookupType('squareup.capital.external.business.models.offers.RepaymentTerms.FixedPayments');
fixType(RepaymentTerms.FixedPayments, {
  paymentAmount: {
    required: true
  },
  finalPaymentAmount: {
    required: true
  },
  paymentCount: {
    required: true
  },
  paymentFrequency: {
    required: true
  }
});
Builder.createAndAttachToType(RepaymentTerms.FixedPayments);
/**
 * Intentionally not setting up an iCalendar recurrence rule definition
 * here. This is much simpler than that RFC and this cannot have a start
 * date until the application is approved.
 *
 * SOURCE PaymentFrequency @ squareup/capital/external/business/models/offers.proto at 264:5
 */
RepaymentTerms.FixedPayments.PaymentFrequency = $root.lookupEnum('squareup.capital.external.business.models.offers.RepaymentTerms.FixedPayments.PaymentFrequency').values;